<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Seguimiento de productos segun venta
    </h2>
    <MainProductTraking />
  </div>
</template>

<script>
import MainProductTraking from "@/components/Reports/ProductTraking/MainProductTraking.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "ProductTraking",
  components: {
    MainProductTraking,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
